module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ1_3.d02d3b6f.svg";